import {connect} from "react-redux";
import CompleteValetActivity from "./Complete";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {viewActivity} from "../../../../service/Activity/action";
import {saveActivity, getPendingActivity, accountById} from "../../../../service/Valet/action";
import {activityTypes, getSenior} from "../../../../service/Dealer/action";
import {markAttendance} from "../../../../service/DCC/action";
import {errorLogs} from "../../../../service/FasttagToll/action";
import {isUserCheckInForModule} from "../../../../service/Account/action";
const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    senior: state.Dealer.senior,
    activityByIdDetails:state.Activity.activityByIdDetails,
    saveActivityRes:state.Valet.saveActivityRes,
    pendingActivity:state.Valet.pendingActivity,
    activityTypesDetails:state.Dealer.activityTypesDetails,
    accountDetailsByIdData:state.Valet.accountById,
    attendance:state.DCC.attendance,
    userCheckInForModule:state.Dropdown.userCheckInForModule,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            viewActivity,
            saveActivity,
            getPendingActivity,
            activityTypes,
            getSenior,
            accountById,
            errorLogs,
            markAttendance,
            isUserCheckInForModule
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompleteValetActivity);
